

























































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {CatalogueMatchDTO, SideDesignation, CatalogueMatchInputDTO, CatalogueMatchListDTO} from "@/dtos/sqe-dtos";

@Component
export default class Reference extends Vue{
  @Prop()
  existingMatch?: CatalogueMatchDTO | null

  @Prop()
  suggestion?: CatalogueMatchDTO | null

  get canBeCreated() {
    return this.existingMatch === null
  }

  get canBeConfirmed() {
    return this.existingMatch !== null && (this.existingMatch?.confirmed === null)
  }

  get canBeRejected() {
    return this.existingMatch !== null && (this.existingMatch?.confirmed === null || this.existingMatch?.confirmed)
  }

  get canBeReadded() {
    return this.existingMatch !== null && this.existingMatch?.confirmed === false
  }

  get hasCompleteEditionData() {
    return this.newEditionName !== ''
      && this.newEditionLoc1 !== ''
      && this.newEditionSide !== ''
  }

  get displayImageReference() {
    return this.existingMatch === null ?
        `${ this.$store.state.image_catalog_id || "N/A" } ${ this.$store.state.imageSide || "N/A" }`
        : `${this.existingMatch?.imagedObjectId} ${this.existingMatch?.catalogSide}`
  }

  private newEditionName: string = ''
  private newEditionVolume: string = ''
  private newEditionLoc1: string = ''
  private newEditionLoc2: string = ''
  private newEditionSide: string = ''
  private editionSideOpt = ['recto', 'verso']
  private newCommentary: string | undefined | null = ''
  private badInput: boolean = false
  private commentary: boolean = false

  dateFormat(dateString: string | null): string {
    if (dateString === null)
      return 'N/A'

    const [date, time] = dateString.split('T')
    const [year, month, day] = date.split('-')

    return `${day}–${month}–${year} ${time}`
  }

  showComment() {
    this.commentary = true
  }

  created() {
    if (this.existingMatch !== undefined && this.existingMatch !== null) {
      this.newEditionName = this.existingMatch.editionName
      this.newEditionVolume = this.existingMatch.editionVolume
      this.newEditionLoc1 = this.existingMatch.editionLocation1
      this.newEditionLoc2 = this.existingMatch.editionLocation2
      this.newEditionSide = this.existingMatch.catalogSide?.toString() ?? 'recto'
      this.newCommentary = this.existingMatch.comment
    } else if (this.suggestion !== undefined && this.suggestion !== null) {
      this.newEditionName = this.suggestion.editionName
      this.newEditionVolume = this.suggestion.editionVolume
      this.newEditionLoc1 = this.suggestion.editionLocation1
      this.newEditionLoc2 = this.suggestion.editionLocation2
      this.newEditionSide = this.suggestion.catalogSide?.toString() ?? 'recto'
    }
  }

  /* Button actions */

  // TODO: all of these should fire a message to let the system know to reload matches
  //  (or can we directly add/remove them from the store on success)

  async confirm() {
    if ((this.canBeConfirmed || this.canBeReadded) && this.existingMatch?.matchId) {
      await this.$com.sqeComms?.postV1CatalogueConfirmMatchIaaEditionCatalogToTextFragmentId(this.existingMatch.matchId)
      const newMatches = (await this.$com.sqeComms?.getV1CatalogueTextFragmentsTextFragmentIdImagedObjects(this.$store.state.col_id)) as CatalogueMatchListDTO
      const actualMatch = newMatches.matches.filter(x => x.matchId === this.existingMatch?.matchId)
      if (actualMatch.length >= 1) {
        this.$store.commit('matchChooserReloadSet', true)
        this.$store.commit('matchCommitReloadSet', true)
      }
    }
  }

  async remove() {
    if (this.canBeRejected && this.existingMatch?.matchId) {
      await this.$com.sqeComms?.deleteV1CatalogueConfirmMatchIaaEditionCatalogToTextFragmentId(this.existingMatch.matchId)
      const newMatches = (await this.$com.sqeComms?.getV1CatalogueTextFragmentsTextFragmentIdImagedObjects(this.$store.state.col_id)) as CatalogueMatchListDTO
      const actualMatch = newMatches.matches.filter(x => x.matchId === this.existingMatch?.matchId)
      if (actualMatch.length >= 1) {
        this.$store.commit('matchChooserReloadSet', true)
        this.$store.commit('matchCommitReloadSet', true)
      }

    }
  }

  async create() {
    if (this.canBeCreated && this.hasCompleteEditionData) {
      try {
        const payload1 = this.createSubmitPayload(false)
        const payload2 = Object.assign({}, payload1, {
          catalogSide: payload1.catalogSide === 'recto' ? 'verso' : 'recto',
          editionSide: payload1.editionSide === 'recto' ? 'verso' : 'recto'
        })
        await this.$com.sqeComms?.postV1Catalogue(payload1)
        await this.$com.sqeComms?.postV1Catalogue(payload2)
        const newMatches = (await this.$com.sqeComms?.getV1CatalogueTextFragmentsTextFragmentIdImagedObjects(this.$store.state.col_id)) as CatalogueMatchListDTO
        const actualMatch = newMatches.matches.filter((x: CatalogueMatchDTO) => this.$store.state.matches.map((x: CatalogueMatchDTO) => x.matchId).indexOf(x.matchId) === -1)
        console.log(newMatches)
        console.log(actualMatch)
        if (actualMatch.length >= 1) {
          this.$store.commit('matchChooserReloadSet', true)
          this.$store.commit('matchIdSet', actualMatch[0].matchId)
          this.$store.commit('matchCommitReloadSet', true)
        }
        // await this.$com.sqeComms?.postV1Catalogue(payload2)
      } catch (err) {
        alert(err);
      }
    } else this.badInput = true
  }

  createSubmitPayload(confirmed: boolean): CatalogueMatchInputDTO {
    return {
      catalogSide: this.$store.state.imageSide as SideDesignation,
      imagedObjectId: this.$store.state.image_catalog_id as string,
      manuscriptId: this.$store.state.scroll_id,
      manuscriptName: this.$store.state.manuscript_name,
      editionName: this.newEditionName,
      editionVolume: this.newEditionVolume,
      editionLocation1: this.newEditionLoc1,
      editionLocation2: this.newEditionLoc2,
      editionSide: this.newEditionSide as SideDesignation,
      textFragmentId: this.$store.state.col_id,
      editionId: this.$store.state.scroll_id,
      confirmed: confirmed,
      comment: this.newCommentary === '' || this.newCommentary === undefined ? null : this.newCommentary
    } as CatalogueMatchInputDTO
  }
}
